import { Link } from "@tanstack/react-router";
import { buildTagCloud } from "@/lib/seo-routes";
import { useMemo } from "react";

export function TagCloud() {
  const groups = useMemo(() => {
    const tags = buildTagCloud();
    return {
      from: tags.filter((t) => t.type === "from"),
      to: tags.filter((t) => t.type === "to"),
      country: tags.filter((t) => t.type === "country"),
      theme: tags.filter((t) => t.type === "theme"),
    };
  }, []);

  return (
    <section className="border-t border-border/50 bg-muted/20 py-10">
      <div className="container mx-auto px-4 space-y-8">
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold">Tanie loty z Polski</h2>
          <Cloud tags={groups.from} />
        </div>
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold">Popularne kierunki</h2>
          <Cloud tags={groups.to} />
        </div>
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold">Według typu podróży</h2>
          <Cloud tags={groups.theme} variant="accent" />
        </div>
        <div>
          <h2 className="mb-3 font-display text-2xl font-bold">Loty według kraju</h2>
          <Cloud tags={groups.country} dense />
        </div>
      </div>
    </section>
  );
}

function Cloud({
  tags, dense, variant,
}: { tags: { label: string; href: string }[]; dense?: boolean; variant?: "accent" }) {
  const base =
    "rounded-full border border-border/60 bg-background/60 px-3 py-1.5 text-xs font-medium text-muted-foreground transition hover:border-primary/60 hover:bg-primary/10 hover:text-foreground";
  const accent =
    "rounded-full border border-primary/40 bg-primary/10 px-3 py-1.5 text-xs font-semibold text-foreground transition hover:bg-primary/20";
  const cls = variant === "accent" ? accent : base;
  return (
    <div className={`flex flex-wrap ${dense ? "gap-1.5" : "gap-2"}`}>
      {tags.map((t) => (
        <Link key={t.href + t.label} to={t.href} className={cls}>
          {t.label}
        </Link>
      ))}
    </div>
  );
}
